import { MessagePlugin } from 'tdesign-vue-next';
import router from '@/router';

export const checkBrowser = () => {
  const SHOWED_FLAG = 'checkBrowserShowed';
  const SHOWED_VALUE = '1';
  const showTipsPages = ['Register', 'Login'];
  // 是否展示过了
  const isShowed = () => localStorage.getItem(SHOWED_FLAG) === SHOWED_VALUE;

  const setShowed = () => {
    localStorage.setItem(SHOWED_FLAG, SHOWED_VALUE);
  };

  setTimeout(() => {
    const { name } = router.currentRoute.value;
    if (!showTipsPages.includes(name as string)) return;
    // 一些基于谷歌浏览器内核的浏览器
    const excludeBrowsers = ['Edg', 'QQBrowser', 'OPR', 'QuarkPC', 'Firefox', 'HBPC'];

    // 判断是不是chrome浏览器
    const isChrome =
      navigator.userAgent.includes('Chrome') &&
      // 排除一些基于谷歌浏览器内核的浏览器
      !excludeBrowsers.some((browser) => navigator.userAgent.includes(browser)) &&
      // chrome浏览器特有的插件Chrome PDF Plugin
      (navigator.plugins && navigator.plugins.length
        ? Array.from(navigator.plugins).some((p) => p.name === 'Chrome PDF Viewer')
        : true);

    if (isChrome || isShowed()) return;

    MessagePlugin.warning({
      content: '您好，为了您更好体验供应商小课堂各功能，推荐使用Google Chrome浏览器',
      attach: () => document.body,
      duration: 4000,
      onDurationEnd: () => {
        setShowed();
      },
    });
  }, 500);
};
